function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Fill 1",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.8887 15.8956H17.8407C15.9437 15.8956 14.3997 14.3526 14.3987 12.4566C14.3987 10.5586 15.9427 9.01461 17.8407 9.01361H21.8887C22.3027 9.01361 22.6387 9.34961 22.6387 9.76361C22.6387 10.1776 22.3027 10.5136 21.8887 10.5136H17.8407C16.7697 10.5146 15.8987 11.3856 15.8987 12.4556C15.8987 13.5246 16.7707 14.3956 17.8407 14.3956H21.8887C22.3027 14.3956 22.6387 14.7316 22.6387 15.1456C22.6387 15.5596 22.3027 15.8956 21.8887 15.8956Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Fill 3",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.2983 13.1436H17.9863C17.5723 13.1436 17.2363 12.8076 17.2363 12.3936C17.2363 11.9796 17.5723 11.6436 17.9863 11.6436H18.2983C18.7123 11.6436 19.0483 11.9796 19.0483 12.3936C19.0483 12.8076 18.7123 13.1436 18.2983 13.1436Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Clip 6",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 3H22.6386V22.1729H2V3Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill 5",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.99757 4.5C5.51757 4.5 3.49957 6.518 3.49957 8.998V16.175C3.49957 18.655 5.51757 20.673 7.99757 20.673H16.6416C19.1216 20.673 21.1386 18.655 21.1386 16.175V8.998C21.1386 6.518 19.1216 4.5 16.6416 4.5H7.99757ZM16.6416 22.173H7.99757C4.69057 22.173 1.99957 19.482 1.99957 16.175V8.998C1.99957 5.69 4.69057 3 7.99757 3H16.6416C19.9486 3 22.6386 5.69 22.6386 8.998V16.175C22.6386 19.482 19.9486 22.173 16.6416 22.173Z",
  fill: "black"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Fill 8",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.6846 9.03809H7.28558C6.87158 9.03809 6.53558 8.70209 6.53558 8.28809C6.53558 7.87409 6.87158 7.53809 7.28558 7.53809H12.6846C13.0986 7.53809 13.4346 7.87409 13.4346 8.28809C13.4346 8.70209 13.0986 9.03809 12.6846 9.03809Z",
  fill: "black"
});

var SvgBilling = function SvgBilling(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light-Outline/Billing"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wallet"
  }, _ref2, _ref3, /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 21,
    height: 20
  }, _ref4), _ref5), _ref6)));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBilling, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Billing.5a7a4ecc.svg";
export { ForwardRef as ReactComponent };